import { React, useRef, useState } from "react";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import Form from "react-bootstrap/Form";
import { Col, Row } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";

import { LoadingSpinner, errorMsg, success } from "../Shared";
import { Common, CommonPages, DataType, EditProfileConstants, Regex, SUCCESS, VALIDATION, TERMSCONDITIONS } from "../../helper";
import { MappixDesign } from "../RegistrationForm";
import * as commonApi from "../../api/commonApi";
import { SessionStorage, isEmptyArray } from "../../util";
import { clearStore } from "../..";

import "../../assets/stlyes/Registration/NewRegistration.scss";

import HideVisibility from "../../assets/images/IconNotVisible1.png";
import ShowVisibility from "../../assets/images/IconVisible1.png";
import HexagonCharacter from "../../assets/images/HexagonCharacter.png";
import { Tooltip } from "@material-ui/core";

const SetPassword = () => {
  const newPasswordRef = useRef(null);
  const confirmPasswordRef = useRef(null);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [inputType, setInputType] = useState(DataType.Password)
  const [btnImage, setBtnImage] = useState(HideVisibility);
  const [inputTypeNew, setInputTypeNew] = useState(DataType.Password)
  const [btnImageNew, setBtnImageNew] = useState(HideVisibility);
  const [isChecked, setIsChecked] = useState(false);
  const [isSubmitEnabled, setIsSubmitEnabled] = useState(false);

  const user = useSelector((state) => state.newUser.userData);

  const PasswordUpdateValidationSchema = Yup.object().shape({
    firstName: Yup.string().trim(" ").max(25, Common.LengthRestriction).required(Common.Required),
    lastName: Yup.string().trim(" ").max(25, Common.LengthRestriction).required(Common.Required),
    newPassword: Yup.string().required(Common.Required).matches(Regex.PasswordRegExp, Common.PasswordsMustContain).min(8, VALIDATION.PASSWORD_MUST_HAVE_MINIMUM_8_CHARACTERS),
    confirmPassword: Yup.string().oneOf([Yup.ref("newPassword"), null], VALIDATION.PASSWORD_MUST_MATCH).required()
  });

  const _togglePasswordVisibility = () => {
    if (inputType === DataType.Password) {
      setBtnImage(ShowVisibility);
      setInputType(DataType.Text);
    }
    if (inputType === DataType.Text) {
      setBtnImage(HideVisibility);
      setInputType(DataType.Password)
    }
  }

  const _toggleNewPasswordVisibility = () => {
    if (inputTypeNew === DataType.Password) {
      setBtnImageNew(ShowVisibility);
      setInputTypeNew(DataType.Text);
    }
    if (inputTypeNew === DataType.Text) {
      setBtnImageNew(HideVisibility);
      setInputTypeNew(DataType.Password)
    }
  }

  const password = async (formData) => {
    setIsLoading(true);
    if (formData.newPassword === formData.confirmPassword) {
      const updatePassword = await commonApi.setPassword(formData);
      if (isEmptyArray(updatePassword)) {
        success(SUCCESS.PASSWORD_UPDATED)
        clearStore();
        setIsLoading(true)
        SessionStorage.clearAll();
        navigate(CommonPages.login)
        setIsLoading(false)
        navigate(CommonPages.login)
        window.location.reload()
      } else {
        errorMsg(Common.UnableToPerformAction)
      }
    }
    setIsLoading(false);
  }

  const handleCheckboxClick = () => {
    setIsChecked(!isChecked);
    setIsSubmitEnabled(!isChecked);
  };

  return (
    <>
      <div className="RegPage">
        {isLoading && <LoadingSpinner />}<div className="left-part">
          <div className="first-div"><MappixDesign /></div>
        </div>
        <div className="right-part">
          <div className="first-div">
            <h3 className="_welcome-title">{Common.SetPassword}</h3>
            <p className="_welcome-subtitle">{Common.PleaseCreateYourUniqueUserLogin}</p>
            <Formik initialValues={{ firstName: "", lastName: "", newPassword: "", confirmPassword: "", }} validationSchema={PasswordUpdateValidationSchema}
              validate={() => { const errors = {}; return errors; }}
              onSubmit={(values, { setSubmitting }) => {
                setSubmitting(true);
                const formData = {
                  inviteId: user.inviteId,
                  password: values.newPassword,
                  firstName: values.firstName,
                  lastName: values.lastName
                }; password(formData);
              }}>
              {({ values, errors, touched, handleChange, handleBlur, handleSubmit, }) => (
                <Form onSubmit={handleSubmit}>
                  <Row className="d-flex flex-column" style={{ gap: "30px" }}>
                    <Col className="d-flex" >
                      <Form.Group>
                        <Form.Label>{EditProfileConstants.FirstName}</Form.Label>
                        <Form.Control id="userNamePlaceholder" type="text" name="firstName" placeholder="First Name" onChange={handleChange} onBlur={handleBlur} value={values.firstName} autoComplete="off" className={touched.firstName && errors.firstName ? "user_name" : "user_name_active"} />&nbsp;
                        {touched.firstName && errors.firstName ? (<p className="error-message enterOTP">{errors.firstName}</p>) : <p>{""}</p>}
                      </Form.Group>
                      <Form.Group style={{ marginLeft: "30px" }}>
                        <Form.Label>{EditProfileConstants.LastName}</Form.Label>
                        <Form.Control id="userNamePlaceholder" type="text" name="lastName" placeholder="Last Name" onChange={handleChange} onBlur={handleBlur} value={values.lastName} autoComplete="off" className={touched.firstName && errors.firstName ? "user_name" : "user_name_active"} />&nbsp;
                        {touched.lastName && errors.lastName ? (<p className="error-message enterOTP">{errors.lastName}</p>) : <p>{""}</p>}
                      </Form.Group>
                    </Col>
                    <Col className="d-flex">
                      <Form.Group className="form-group" style={{ width: "min-content" }}>
                        <Form.Label>{Common.Password}</Form.Label>
                        <Form.Control type={inputType} name="newPassword" id="newPassword" placeholder="Password" onChange={handleChange} onBlur={handleBlur} value={values.newPassword} className={touched.newPassword && errors.newPassword ? "user_password" : "user_password_active"} ref={newPasswordRef} autoComplete="off" />
                        <span onClick={_togglePasswordVisibility} onKeyDown={(e) => { e.key === "Enter" && _togglePasswordVisibility() }} tabIndex={0} role="button">
                          <img src={btnImage} alt="Acc" className="visibleLogo" style={{ width: "20px", height: "12px" }} />
                        </span>
                        {touched.newPassword && errors.newPassword && (<p className="error-message-new-password">{errors.newPassword}</p>)}
                      </Form.Group>
                      <Form.Group className="form-group" style={{ marginLeft: "30px" }}>
                        <Form.Label>{Common.Confirmpassword}</Form.Label>
                        <Form.Control type={inputTypeNew} name="confirmPassword" id="confirmPassword" placeholder="Confirm Password" onChange={handleChange} onBlur={handleBlur} value={values.confirmPassword} className={touched.confirmPassword && errors.confirmPassword ? "user_password" : "user_password_active"} ref={confirmPasswordRef} autoComplete="off" />
                        <span onClick={_toggleNewPasswordVisibility} onKeyDown={(e) => { e.key === "Enter" && _toggleNewPasswordVisibility() }} tabIndex={0} role="button">
                          <img src={btnImageNew} alt="Acc" className="visibleLogo" style={{ width: "20px", height: "12px" }} />
                        </span>
                        {touched.confirmPassword && errors.confirmPassword && (<p className="error-message">{errors.confirmPassword}</p>)}
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="checkBox">
                    <Col className="d-flex flex-row">
                      <label className="d-flex"><input type="checkbox" checked={isChecked} onClick={handleCheckboxClick} className="checkeddd" /><p className="termCondition">{TERMSCONDITIONS.TC}</p></label>
                    </Col>
                  </Row>
                  <Form.Group className="submit-button-div ">
                    <Tooltip title={!isSubmitEnabled ? Common.PleaseCheckTermsAndConditions : ""} placement="top">
                      <button type="submit" className="submit-button" disabled={!isSubmitEnabled}>{EditProfileConstants.UpdatePassword}</button>
                    </Tooltip>
                  </Form.Group>
                </Form>
              )}
            </Formik>
          </div>
          <div className="second-div"><img src={HexagonCharacter} className="hexagon-logo" alt="hexagon-character"></img></div>
        </div>
      </div>
    </>
  );
}

export { SetPassword };